<template>
  <v-container text-xs-left fill-height>
    <v-layout wrap justify-center align-center>
      <v-flex xs12 md6 lg6>
        <v-card class="pa-4">
          <h4>【回答期間】</h4>
          <p>{{ openingDate }} 〜 {{ closingDate }}</p>
          <h2>回答期間は終了しました。ご協力ありがとうございました。</h2><br />
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { Target } from '@/model/models'

export default {
  name: 'Expiration',
  computed: {
    target () {
      return Target.query().first()
    },
    gaTrackingId () {
      return this.target['ga_tracking_id']
    },
    openingDate () {
      const openingDate = new Date(this.target['opening_date'])

      return `${openingDate.getFullYear()}/${openingDate.getMonth() + 1}/${openingDate.getDate()} ${openingDate.getHours()}:${openingDate.getMinutes()}`
    },
    closingDate () {
      let closingDate = new Date(this.target['closing_date'])
      return `${closingDate.getFullYear()}/${closingDate.getMonth() + 1}/${closingDate.getDate()} ${closingDate.getHours()}:${closingDate.getMinutes()}`
    }
  },
  created () {
    gtag('config', this.gaTrackingId, { 'page_path': this.$route.path })
  }
}
</script>

<style scoped>

</style>
